import { formatValue, getValClassName } from './common';

import type { ReactNode } from 'react';
import type { ChangelogRule, FormatterContext } from './types';

export const LOCATIONS_ORDER = 100;

function formatArea(value: unknown): ReactNode {
  if (typeof value !== 'number') {
    return '-';
  }
  return (
    <>
      {`${(value / 1000000).toFixed(2)} km`}
      <sup>2</sup>
    </>
  );
}

function renderChangedFrom(message: string, lhs: ReactNode, rhs: ReactNode, { formatMessage }: FormatterContext) {
  return (
    <div className={getValClassName('edit')}>
      {`${message} `}
      <b>{lhs}</b>
      {` ${formatMessage({ defaultMessage: 'to', id: 'changelogModal.message.to' })} `}
      <b>{rhs}</b>
    </div>
  );
}

export const locationsRules: ChangelogRule[] = [
  {
    format: (change, context) =>
      renderChangedFrom(
        context.formatMessage({
          defaultMessage: 'Number of zones changed from',
          id: 'changelogModal.message.zonesNumber'
        }),
        formatValue(change.lhs),
        formatValue(change.rhs),
        context
      ),
    order: LOCATIONS_ORDER,
    regex: /^E\.zones\.length$/,
    section: 'locations'
  },
  {
    format: (change, context) =>
      renderChangedFrom(
        context.formatMessage({ defaultMessage: 'Total area changed from', id: 'changelogModal.message.totalArea' }),
        formatArea(change.lhs),
        formatArea(change.rhs),
        context
      ),
    order: LOCATIONS_ORDER + 1,
    regex: /^E\.zones\.area$/,
    section: 'locations'
  }
];
